module.exports = __webpack_public_path__ + "img/garmin-watch.b78395fa.jpg";